import { Widget } from '../Widget';
import { WidgetType } from '../types';
import {
    LabelWidgetConfiguration,
    LabelWidgetConfigurationDetails,
    ZodLabelWidgetConfigurationDetails,
} from './types';

export class LabelWidget extends Widget {
    type: WidgetType.LABEL = WidgetType.LABEL;
    declare config: LabelWidgetConfigurationDetails;

    constructor(widgetConfiguration: LabelWidgetConfiguration, zoneId: number) {
        super(widgetConfiguration, zoneId);
    }

    /**
     * Initialize Label Widget
     */
    async initialize(): Promise<void> {
        await super.initialize();
        if (!this.config.text) {
            this.hasContentToPlay = false;
        }
    }

    protected validateConfigurationDetails(
        maybeLabelWidgetConfigurationDetails: LabelWidgetConfigurationDetails
    ): LabelWidgetConfigurationDetails {
        return ZodLabelWidgetConfigurationDetails.parse(maybeLabelWidgetConfigurationDetails);
    }

    /**
     * @inheritdoc
     */
    async getReadyForDisplay(): Promise<void> {
        // Add the Label text
        // Using innerHTML because some layouts have HTML code
        // in the label widget.
        if (!this.config.text) {
            this.hasContentToPlay = false;
        } else {
            this.hasContentToPlay = true;
            this.wrapperElement.innerHTML = this.config.text;
        }
    }
}
